package com.daytimegaming.ourdailyfinances.presentation.util

import kotlinx.datetime.LocalDate
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.LocalTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.format
import kotlinx.datetime.format.MonthNames.Companion.ENGLISH_FULL
import kotlinx.datetime.format.Padding
import kotlinx.datetime.format.char
import kotlinx.datetime.toInstant
import kotlinx.datetime.toLocalDateTime
import kotlin.time.ExperimentalTime
import kotlin.time.Instant

fun LocalDate.monthDayFormat(): String = format(
    LocalDate.Format {
        monthNumber()
        char('/')
        day(padding = Padding.ZERO)
    }
)

fun LocalDate.monthDayYearFormat(): String = format(
    LocalDate.Format {
        monthNumber()
        char('/')
        day(padding = Padding.ZERO)
        char('/')
        year()
    }
)

fun LocalDate.monthNameYearFormat(): String = format(
    LocalDate.Format {
        monthName(ENGLISH_FULL)
        char(' ')
        year()
    }
)

fun LocalDate.monthNameDayYearFormat(): String = format(
    LocalDate.Format {
        monthName(ENGLISH_FULL)
        char(' ')
        day(padding = Padding.ZERO)
        chars(", ")
        year()
    }
)

fun LocalTime.hourMinuteAmPmMarketFormat() = format(
    LocalTime.Format {
        amPmHour(padding = Padding.NONE)
        char(':')
        minute()
        amPmMarker("am", "pm")
    }
)

fun convertMillisToDate(millis: Long): LocalDate {
    return convertMillisToLocalDateTime(millis).date
}

fun convertMillisToTime(millis: Long): LocalTime {
    return convertMillisToLocalDateTime(millis).time
}

fun convertMillisToLocalDateTime(millis: Long): LocalDateTime {
    val instant: Instant = Instant.fromEpochMilliseconds(millis)
    val timeZone: TimeZone = TimeZone.currentSystemDefault()

    return instant.toLocalDateTime(timeZone)
}

@OptIn(ExperimentalTime::class)
fun LocalDateTime.toLocalTimeZone() = toInstant(TimeZone.UTC).toLocalDateTime(TimeZone.currentSystemDefault())

fun formatIsoDateTime(isoString: String): String {
    return try {
        val instant = Instant.parse(isoString)
        val localDateTime = instant.toLocalDateTime(TimeZone.currentSystemDefault())
        val dateStr = localDateTime.date.monthDayYearFormat()
        val timeStr = localDateTime.time.hourMinuteAmPmMarketFormat()
        "$dateStr $timeStr"
    } catch (e: Exception) {
        isoString
    }
}

fun findLatestIsoTimestamp(timestamps: Iterable<String?>): String? {
    return timestamps
        .filterNotNull()
        .mapNotNull { str ->
            runCatching { Instant.parse(str) }.getOrNull()
        }
        .maxOrNull()
        ?.toString()
}